import { IsubmitFeedback } from '../../schemas/Menu/Menu.Schema';

export class Feedback implements IsubmitFeedback {

  deviceUUID?: string;
  upn!: string;
  rating!: number;
  carrierId?: string;
  carrierName?: string;
  feedback?: string;
  firstName?: string;
  lastName?: string;
  devicePlatform?: string;
  deviceManufacturer?: string;
  deviceModel?: string;
  appVersion?: string;
  deviceOSVersion?: string;

  getRequestPayload() {
    const excludedProperties = [ "deviceUUID", "appVersion", "deviceOSVersion"  ];
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function" && !excludedProperties.includes(key)) input[key] = value;
    }
    return {
      mutation: {
        feedback: {
          __args: {
            input
          }
        }
      }
    };
  }
}
